export default function PenaltyKicksIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path d="M2 54h60v8H2z" fill="#3E9E48" />
      <path d="M8 12h48v40" fill="none" stroke="#F4F7FA" strokeWidth="4" strokeLinejoin="round" />
      <path d="M8 12v40" stroke="#F4F7FA" strokeWidth="4" />
      <path
        d="M16 12v40M24 12v40M32 12v40M40 12v40M48 12v40M8 20h48M8 28h48M8 36h48M8 44h48"
        stroke="#F4F7FA"
        strokeOpacity="0.35"
        strokeWidth="1.4"
      />
      {/* Keeper diving */}
      <g transform="rotate(-35 22 34)">
        <rect x="16" y="26" width="12" height="18" rx="5" fill="#FF8A1F" />
        <circle cx="22" cy="21" r="5" fill="#E2AD86" />
        <circle cx="15" cy="17" r="3.4" fill="#FFFFFF" />
        <circle cx="29" cy="17" r="3.4" fill="#FFFFFF" />
      </g>
      {/* Ball flying into the top corner */}
      <path d="M30 56l12-28" stroke="#FFFFFF" strokeOpacity="0.5" strokeWidth="3" strokeLinecap="round" strokeDasharray="2 4" />
      <circle cx="46" cy="22" r="8" fill="#F4F7FA" stroke="#1B1F26" strokeWidth="2" />
      <path d="M46 18l3.5 2.5-1.3 4h-4.4l-1.3-4z" fill="#1B1F26" />
    </svg>
  );
}
